// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5e6e4d78","239":"4bb2f6fe","453":"f091ad37","455":"e2410bf7","867":"ada1e556"}[chunkId] + ".chunk.js";
};